import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Nemt from "./Nemt";
import { StyleSheet } from "@react-pdf/renderer";
const Products = () => {
    const styles = StyleSheet.create({
      page: {
      flexDirection: "row",
      backgroundColor: "#61dafb",
    }
    }); 
  const navigate = useNavigate();  
  
  const handleNemt = () => {
    console.log("NEMT button clicked");
    navigate("/products/nemt");
  }
  return (
    <div>
      <h2>ISW Products</h2>
      <p>Look at our Non-Emergency Medical Transportation (NEMT) software solutions.</p>
      <br />
      <button onClick={handleNemt}>NEMT Software Solutions</button>
      <br />
    </div>
  );
};

export default Products;    
